/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ServiceAmountVo } from './ServiceAmountVo';
import {
    ServiceAmountVoFromJSON,
    ServiceAmountVoFromJSONTyped,
    ServiceAmountVoToJSON,
    ServiceAmountVoToJSONTyped,
} from './ServiceAmountVo';

/**
 * 
 * @export
 * @interface RecommendCodeBindDetailOrderItemVo
 */
export interface RecommendCodeBindDetailOrderItemVo {
    /**
     * 订单id
     * @type {number}
     * @memberof RecommendCodeBindDetailOrderItemVo
     */
    orderId?: number;
    /**
     * 订单编号
     * @type {string}
     * @memberof RecommendCodeBindDetailOrderItemVo
     */
    orderCode?: string;
    /**
     * 下单会员名
     * @type {string}
     * @memberof RecommendCodeBindDetailOrderItemVo
     */
    orderUserName?: string;
    /**
     * 出库日期
     * @type {string}
     * @memberof RecommendCodeBindDetailOrderItemVo
     */
    outboundDate?: string;
    /**
     * 各附加服务金额及分成明细
     * @type {Array<ServiceAmountVo>}
     * @memberof RecommendCodeBindDetailOrderItemVo
     */
    services?: Array<ServiceAmountVo>;
    /**
     * 小计（该订单附加服务金额合计）
     * @type {number}
     * @memberof RecommendCodeBindDetailOrderItemVo
     */
    subtotalAmount?: number;
    /**
     * 业绩（该订单分成金额合计）
     * @type {number}
     * @memberof RecommendCodeBindDetailOrderItemVo
     */
    commissionAmount?: number;
}

/**
 * Check if a given object implements the RecommendCodeBindDetailOrderItemVo interface.
 */
export function instanceOfRecommendCodeBindDetailOrderItemVo(value: object): value is RecommendCodeBindDetailOrderItemVo {
    return true;
}

export function RecommendCodeBindDetailOrderItemVoFromJSON(json: any): RecommendCodeBindDetailOrderItemVo {
    return RecommendCodeBindDetailOrderItemVoFromJSONTyped(json, false);
}

export function RecommendCodeBindDetailOrderItemVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecommendCodeBindDetailOrderItemVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'orderUserName': json['orderUserName'] == null ? undefined : json['orderUserName'],
        'outboundDate': json['outboundDate'] == null ? undefined : json['outboundDate'],
        'services': json['services'] == null ? undefined : ((json['services'] as Array<any>).map(ServiceAmountVoFromJSON)),
        'subtotalAmount': json['subtotalAmount'] == null ? undefined : json['subtotalAmount'],
        'commissionAmount': json['commissionAmount'] == null ? undefined : json['commissionAmount'],
    };
}

export function RecommendCodeBindDetailOrderItemVoToJSON(json: any): RecommendCodeBindDetailOrderItemVo {
    return RecommendCodeBindDetailOrderItemVoToJSONTyped(json, false);
}

export function RecommendCodeBindDetailOrderItemVoToJSONTyped(value?: RecommendCodeBindDetailOrderItemVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'orderCode': value['orderCode'],
        'orderUserName': value['orderUserName'],
        'outboundDate': value['outboundDate'],
        'services': value['services'] == null ? undefined : ((value['services'] as Array<any>).map(ServiceAmountVoToJSON)),
        'subtotalAmount': value['subtotalAmount'],
        'commissionAmount': value['commissionAmount'],
    };
}

